import React from 'react';
import { FormProps, Modal, ModalBody } from 'react-bootstrap';
import EmailForm, { Email } from './EmailForm';

export type customEmailFormModalProps = React.PropsWithoutRef<{
  showModal: boolean;
  existingEmail?: Email;
  handleClose: () => void;
  handleSubmit: (formData: any) => void;
  formProps?: FormProps;
}>;

const EmailFormModal = ({
  showModal = false,
  existingEmail,
  handleClose,
  handleSubmit,
  formProps,
  ...props
}: customEmailFormModalProps) => {
  return (
    <Modal show={showModal} onHide={handleClose} {...props} size="lg">
      <ModalBody className="pt-12">
        <EmailForm
          existingEmail={existingEmail}
          {...formProps}
          handleClose={handleClose}
          handleOnSubmit={handleSubmit}
        />
      </ModalBody>
    </Modal>
  );
};

export default EmailFormModal;
